import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { makeArrayRandom } from "../../../../utils/learner";
import { useSelector } from "../../../../store";

export default function WebCorrectOrderHoliday({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [websiteChoices, setWebsiteChoices] = useState({});
    const [selectedChoice, setSelectedChoice] = useState(null);
    const [activeSelect, setActiveSelect] = useState(false);
    const [selectedKeyPrevious, setSelectedKeyPrevious] = useState(null);

    const [initialChoicesCount, setInitialChoicesCount] = useState(Array.isArray(questionData.answer.value)
        ? questionData.answer.value.length
        : Object.keys(questionData.answer.value).length);

    const [availableChoices, setAvailableChoices] = useState(
        makeArrayRandom(data.choices)
    );

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setWebsiteChoices({});
        setSelectedChoice(null);
        setActiveSelect(false);
        setSelectedKeyPrevious(null);
        setInitialChoicesCount((Array.isArray(questionData.answer.value)
            ? questionData.answer.value.length
            : Object.keys(questionData.answer.value).length));
        setAvailableChoices(makeArrayRandom(data.choices));
    }, [question,
        questionData.answer.value,
        data.choices
    ]);

    const handleChoiceClick = (choice) => {
        setSelectedChoice(choice);
        setActiveSelect(true);
        setSelectedKeyPrevious(null);
    };

    const handleChoiceAssign = (index) => {
        if (websiteChoices[index] && !selectedChoice) {
            const choice = data.choices.find((c) => c.value === websiteChoices[index].value);
            setSelectedChoice(choice);
            setSelectedKeyPrevious(index);
        }

        if (selectedChoice && (selectedChoice?.value !== websiteChoices[index]?.value)) {
            let currentWebsiteChoices = {...websiteChoices};
            const previousChoice = websiteChoices[index];

            if (previousChoice) {
                setAvailableChoices((prevChoices) => [
                    ...prevChoices,
                    { ...previousChoice },
                ]);
            }

            // we will check here if coming from previous answer
            if (selectedKeyPrevious !== null) {
                delete currentWebsiteChoices[selectedKeyPrevious];
                setSelectedKeyPrevious(null);
            }
            // updating answer
            currentWebsiteChoices = {
                ...currentWebsiteChoices,
                [index]: {
                    value: selectedChoice.value,
                    image: selectedChoice.image,
                },
            }
            setWebsiteChoices(currentWebsiteChoices);

            if (
                typeof questionData.answer.value === "object" &&
                !Array.isArray(questionData.answer.value)
            ) {

            } else {
                const updatedAnswer = Object.values(currentWebsiteChoices).map(
                    (choice) => choice.value
                );

                const canProceed = true;
                onAnswer({
                    canProceed,
                    answer: updatedAnswer,
                });
            }

            setAvailableChoices((prevChoices) =>
                prevChoices.filter(
                    (item) => item.value !== selectedChoice.value
                )
            );

            setSelectedChoice(null);
            setActiveSelect(false);
        }
    };

    const handleRemoveChoice = (index) => {
        if (!activeSelect) {
            const removedChoice = websiteChoices[index];

            if (removedChoice) {
                setWebsiteChoices((prevChoices) => {
                    const newChoices = { ...prevChoices };
                    delete newChoices[index];

                    if (
                        typeof questionData.answer.value === "object" &&
                        !Array.isArray(questionData.answer.value)
                    ) {
                        const answerKeys = Object.keys(
                            questionData.answer.value
                        );

                        let canProceed = false;
                        const formattedAnswer = answerKeys.reduce(
                            (acc, key, keyIndex) => {
                                acc[key] = newChoices[keyIndex]?.value || null;
                                if (acc[key] !== "" && acc[key] !== null) {
                                    canProceed = true;
                                }
                                return acc;
                            },
                            {}
                        );
  
                        onAnswer({
                            canProceed,
                            answer: formattedAnswer,
                        });
                    } else {
                        const updatedAnswer = Object.values(newChoices).map(
                            (choice) => choice.value
                        );

                        const canProceed = updatedAnswer.length > 0;
                        onAnswer({
                            canProceed,
                            answer: updatedAnswer,
                        });
                    }

                    return newChoices;
                });

                setAvailableChoices((prevChoices) => [
                    ...prevChoices,
                    {
                        value: removedChoice.value,
                        image: removedChoice.image,
                    },
                ]);
            }
        }
    };

    return (
        <Box
            sx={{
                width: "950px",
                margin: "0 auto",
                padding: "10px",
                backgroundColor: "rgb(122, 140, 142)",
            }}
        >
            <Box
                sx={{
                    // maxWidth: "914px",
                    margin: "0 auto",
                    padding: "20px 20px 0 20px",
                    border: "1px dashed white",
                }}
            >
                <Grid
                    container
                    spacing={2}
                    sx={{
                        marginBottom: "10px",
                        flexWrap: "nowrap",
                        display: "flex",
                        "@media (max-width: 470px)": {
                            flexWrap: "wrap",
                        },
                    }}
                >
                    {availableChoices.map((choice, index) => (
                        <Grid item xs={3} key={index} sx={{ width: "15%" }}>
                            <Box sx={{
                                padding: "10px",
                                borderBottom: "10px solid rgb(52, 148, 186)",
                                position: "relative",
                                display: "inline-flex", 
                                alignItems: "center",
                                justifyContent: "space-between", 
                                flexDirection: "column",
                                lineHeight: "1em",
                                fontWeight: "bold", 
                                height: "214px",
                                width: "128px",
                                backgroundColor: "#aad6e7",
                                boxShadow:
                                        selectedChoice?.value === choice.value
                                            ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                            : "none",
                            }}
                            onClick={() => { handleChoiceClick(choice) }}
                            disabled={selectedChoice === choice}
                            >
                                <Box sx={{ 
                                    display: "inline-flex", 
                                    width: "100%",
                                    height: "100%",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    userSelect: "none",
                                    pointerEvents: "none",
                                    fontSize: "18px",
                                    textAlign: "center",
                                }}>
                                    {choice.value}
                                </Box>
                                <Box component="img" 
                                    src={`${imagesResources}${choice.image}`} 
                                    style={{
                                        width: 100
                                    }}
                                    alt={`Img ${choice.value}`}
                                />
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            <Box
                sx={{
                    marginTop: "10px",
                }}
            >
                <Grid
                    container
                    spacing={0}
                    sx={{
                        marginBottom: "10px",
                        flexWrap: "nowrap",
                        display: "flex",
                        "@media (max-width: 470px)": {
                            flexWrap: "wrap",
                        },
                    }}
                >
                    {[...Array(initialChoicesCount)].map((_, index) => (
                        <Grid item xs={3} key={index} sx={{ width: "15%" }}>
                            <Box sx={{
                                    padding: "10px",
                                    position: "relative",
                                    display: "inline-flex", 
                                    alignItems: "center",
                                    justifyContent: "space-between", 
                                    flexDirection: "column",
                                    lineHeight: "1em",
                                    fontWeight: "bold", 
                                    height: "210px",
                                    width: "122px",
                                    backgroundColor: websiteChoices[index]
                                        ? "#aad6e7"
                                        : "white",
                                    boxShadow:
                                            selectedChoice
                                                ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                : "none",
                                    borderTop: websiteChoices[index]
                                        ? "none"
                                        : "10px solid rgb(91, 105, 106)",
                                    fontSize: "20px",
                                }}
                                onClick={() => handleChoiceAssign(index)}
                            >
                            {/* For close button */}
                            {websiteChoices[index] && (
                                <Box className="selected-close-btn"
                                    style={{
                                        top: "0px",
                                        right: "0px",
                                        backgroundColor: "rgb(199, 0, 199)",
                                        fontWeight:
                                            typeof questionData.answer.value ===
                                                "object" &&
                                            !Array.isArray(
                                                questionData.answer.value
                                            )
                                                ? "normal"
                                                : "bold",
                                        width: "17.33px",
                                        maxHeight: "20px",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveChoice(index);
                                    }}
                                >
                                    X
                                </Box>
                            )}
                                <Box sx={{ 
                                    display: "inline-flex", 
                                    width: "100%",
                                    height: "100%",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    userSelect: "none",
                                    pointerEvents: "none",
                                    textAlign: "center",
                                }}>
                                        {websiteChoices[index] ? (
                                            <Box
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    textAlign: "center",
                                                }}
                                            >
                                                <Box>{websiteChoices[index].value}</Box>
                                                <Box component="img" 
                                                    src={`${imagesResources}${websiteChoices[index].image}`}
                                                    style={{
                                                        width: 100,
                                                        marginTop: 20,
                                                    }}
                                                    alt={`Img ${websiteChoices[index].value}`}
                                                />
                                            </Box>
                                        ) :
                                        <Box
                                            component="span"
                                            style={{
                                            color: "rgb(153, 153, 153)",
                                            fontSize: "64px",
                                        }}>{index + 1}</Box>
                                    }
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                    <Grid container sx={{ width: "15%"}}>
                        <Box sx={{
                                padding: "10px",
                                position: "relative",
                                display: "inline-flex", 
                                alignItems: "center",
                                justifyContent: "space-between", 
                                flexDirection: "column",
                                lineHeight: "1em",
                                fontWeight: "bold", 
                                height: "210px",
                                width: "120px",
                                backgroundColor: "#aad6e7",
                            }}>
                                <Box sx={{ 
                                    display: "inline-flex", 
                                    width: "100%",
                                    height: "100%",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    userSelect: "none",
                                    pointerEvents: "none",
                                    fontSize: "24px",
                                    textAlign: "center",
                                }}>
                                    {data.text}
                                </Box>
                                <Box component="img" 
                                    src={`${imagesResources}${data.image}`} 
                                    style={{
                                        width: 100
                                    }}
                                    alt="Img"
                                />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};